module.exports = __webpack_public_path__ + "static/img/s03.9442603d.png";